var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-subheader',[_vm._v("Efetuado em")]),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('initial-date'),_c('final-date')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }